//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'icon-logo-additional-ut',
};
